import styled from 'styled-components';

export const List = styled.ul`
    list-style: none;
    padding: 0;
    gap: 1rem;
`;

export const ListItem = styled.li`
    margin-top: 1.5rem;
`;
